import { render, staticRenderFns } from "./testeCamera2.vue?vue&type=template&id=5fa864fa&"
import script from "./testeCamera2.vue?vue&type=script&lang=js&"
export * from "./testeCamera2.vue?vue&type=script&lang=js&"
import style0 from "./testeCamera2.vue?vue&type=style&index=0&id=5fa864fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports